import { enMessages } from './en';
import { viMessages } from './vi';

export type Messages = typeof viMessages | typeof enMessages;

export const messages = {
  vi: viMessages,
  en: enMessages,
} as const satisfies Record<'vi' | 'en', Messages>;